// ICON_BUTTON_CSS — gemeinsame Icon-Button-Optik fuer Topbar/Sidebar-WCs
// (z.B. <pfs-theme-toggle>, <pfs-notification-bell>).
//
// Ziel: JEDE Environment drueckt ihren Stempel auf — der WC bringt KEINE
// Eigenmeinung (kein Border, keine Marken-Farbe, kein fixer Radius) mit, sondern
// liest alles aus `--pfs-icon-btn-*`-Custom-Properties mit neutralen Token-
// Defaults. Custom-Properties cascaden DURCH Shadow-Grenzen → der Host setzt sie
// EINMAL am Container (Sidebar/Topbar), ALLE Icon-WCs darin folgen automatisch
// (uniformes Hover/Radius/Farbe, inkl. Brand-Tint-on-Hover je Environment).
//
// Vertrag (alle optional, Default in Klammern):
//   --pfs-icon-btn-size        Button-Kantenlaenge            (2.25rem)
//   --pfs-icon-btn-padding     Innenabstand                   (0.5rem)
//   --pfs-icon-btn-radius      Eckenradius                    (0.375rem)
//   --pfs-icon-btn-icon-size   SVG-Groesse                    (1.25rem)
//   --pfs-icon-btn-bg          Grund (Ruhe)                   (transparent)
//   --pfs-icon-btn-border      Border (Ruhe)                  (none)
//   --pfs-icon-btn-fg          Icon-Farbe (Ruhe)              (--pfs-color-on-surface-muted)
//   --pfs-icon-btn-hover-bg    Grund (Hover)                  (--pfs-color-surface-hover)
//   --pfs-icon-btn-hover-fg    Icon-Farbe (Hover, z.B. Brand) (--pfs-color-on-surface)
//   --pfs-icon-btn-hover-border Border-Farbe (Hover)          (transparent)
//   --pfs-icon-btn-focus       Fokus-Ring-Farbe               (--pfs-color-accent)
//
// Verlangt ein `<button part="button">` mit einem `<svg>` darin. `part="button"`
// bleibt als struktureller Escape-Hatch erhalten (::part(button) fuer Spezialfaelle).
export const ICON_BUTTON_CSS = `
button {
  position: relative;
  display: inline-flex; align-items: center; justify-content: center;
  box-sizing: border-box;
  width: var(--pfs-icon-btn-size, 2.25rem);
  height: var(--pfs-icon-btn-size, 2.25rem);
  padding: var(--pfs-icon-btn-padding, 0.5rem);
  border-radius: var(--pfs-icon-btn-radius, 0.375rem);
  background: var(--pfs-icon-btn-bg, transparent);
  border: var(--pfs-icon-btn-border, none);
  color: var(--pfs-icon-btn-fg, var(--pfs-color-on-surface-muted));
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}
button:hover {
  background: var(--pfs-icon-btn-hover-bg, var(--pfs-color-surface-hover));
  color: var(--pfs-icon-btn-hover-fg, var(--pfs-color-on-surface));
  border-color: var(--pfs-icon-btn-hover-border, transparent);
}
button:focus-visible {
  outline: 2px solid var(--pfs-icon-btn-focus, var(--pfs-color-accent));
  outline-offset: 2px;
}
button svg { width: var(--pfs-icon-btn-icon-size, 1.25rem); height: var(--pfs-icon-btn-icon-size, 1.25rem); }
`;
